import { getHTML } from "venuescanner-js/services/api";
import { $ } from "venuescanner-js/tools/elemental";
// Hackiest thing ever, the navbar gets "reloaded" by injecting html, so
// we lose the shortlist button, we have to render it again.
import { renderShortListButton } from "venuescanner-js/react/components/Buttons/ShortListNavButton.jsx";

const hostRedirect = (user) => {
  if (window) {
    if (user.hasVenues) {
      window.location = "/dashboards";
    } else {
      window.location = "/list-venue";
    }
  }
};

const hideOnScroll = () => {};
const reloadNavbar = async () => {
  try {
    const html = $(await getHTML("/auth/navbar")).get(0);
    try {
      const bar = $("nav.ux-navbar");
      if (bar) {
        const shortlistBtn = document.getElementById("short-list-nav-button");
        shortlistBtn.innerHTML = "";

        bar.replaceWith(html);
        renderShortListButton();
      }
      try {
        if (window.unread) window.unread.init();
      } catch (e) {
        console.log("unread");
        console.error(e);
      }
    } catch (e) {
      console.log("replace navbar");
      console.error(e);
    }
  } catch (e) {
    console.log("reloadNavbar");
    console.error(e);
  }
};
window.reloadNavbar = reloadNavbar;
export { hideOnScroll, hostRedirect, reloadNavbar };
